import { Resource } from '@alexandrainst/plana-react-api'
import { Branded } from './types'

export * as types from './types'
export { isDefined } from './type-guards'

export const range = (lowEnd: number, highEnd: number) => {
  const arr = []
  let c = highEnd - lowEnd + 1
  while (c--) {
    arr[c] = highEnd--
  }
  return arr
}

export type HexString = Branded<string, 'HexString'>
/**
 * Convert decimal values to hex string
 * @param decimal number to convert
 * @returns the specified decimal value as a hex string
 */
export function decimalToHexTwosComplement(decimal: number): HexString {
  const size = 6

  if (decimal >= 0) {
    let hexadecimal = decimal.toString(16)

    while (hexadecimal.length % size !== 0) {
      hexadecimal = '' + 0 + hexadecimal
    }

    return hexadecimal as HexString
  } else {
    let hexadecimal = Math.abs(decimal).toString(16)
    while (hexadecimal.length % size !== 0) {
      hexadecimal = '' + 0 + hexadecimal
    }

    let output = ''
    let i = 0
    for (i = 0; i < hexadecimal.length; i++) {
      output += (0x0f - parseInt(hexadecimal[i]!, 16)).toString(16)
    }

    output = (0x01 + parseInt(output, 16)).toString(16)
    return output as HexString
  }
}
export type ColorString = Branded<string, 'ColorString'>
export const propColor = (r: Resource): ColorString => {
  let color = 0
  try {
    color = JSON.parse(r.data.properties).color ?? 0
  } catch {
    // properties string is not valid JSON; fall back to default color
  }
  const hex = decimalToHexTwosComplement(color)
  return ('#' + hex) as ColorString
}

export const errorMessage = (e: unknown) => {
  if (typeof e === 'string') {
    return e
  } else if (e instanceof Error) {
    return e.message
  } else {
    return `Unknown error: ${JSON.stringify(e)}`
  }
}

export const onlyLettersAndNumbers = (input: string) =>
  input && /^[A-Za-z0-9]*$/.test(input)

export const stripTrailingSlash = (str: string) => {
  return str.endsWith('/') ? str.slice(0, -1) : str
}

export const delay = (ms: number): Promise<void> =>
  new Promise((resolve): void => {
    setTimeout(resolve, ms)
  })
